import { ChangeEvent, useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { AgreeToTermsAndConditions, BohoMail, ContactNumber, Email, EnterFirstName, EnterLastName, EnterNumber, FirstName, LastName, Next, State, ZipCode } from "../../../../Constant";
import { VerticalValidationWizardFormPropsType } from "../../../../Type/FormLayoutType";
import ShowError from "../../common/ShowError";

const YourInfoForm = ({ activeCallBack }: VerticalValidationWizardFormPropsType) => {
  const [yourInfoForm, setYourInfoForm] = useState({firstName: "",lastName: "",contact: "",email: "",state: "",zip: "",});
  const { firstName, lastName, contact, email, state, zip } = yourInfoForm;

  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = (name === "rememberNextTime") ? event.target.checked : event.target.value;
    setYourInfoForm({ ...yourInfoForm, [name]: value });
  };

  const handleNextButton = () => {
    if (firstName !== "" &&lastName !== "" &&contact !== "" &&email !== "" &&state !== "" &&zip !== "") activeCallBack(2)
    else ShowError()    
  };

  return (
    <Form className="g-3 needs-validation custom-input" noValidate>
      <Row>
      <Col xxl="4" sm="6" className="mb-3">
        <Label check>{FirstName}<span className="txt-danger">*</span></Label>
        <Input type="text" placeholder={EnterFirstName} name="firstName" value={firstName} onChange={getUserData}/>
      </Col>
      <Col xxl="4" sm="6" className="mb-3">
        <Label check>{LastName}<span className="txt-danger">*</span></Label>
        <Input type="text" placeholder={EnterLastName} name="lastName" value={lastName} onChange={getUserData}/>
      </Col>
      <Col xxl="4" sm="6" className="mb-3">
        <Label check>{Email}<span className="txt-danger">*</span></Label>
        <Input name="email" type="email" placeholder={BohoMail} value={email} onChange={getUserData}/>
      </Col>
      <Col xxl="5" sm="6" className="mb-3">
        <Label check>{State}</Label>
        <Input type="select" name="state" value={state} onChange={getUserData}>
          <option value={""}>Choose...</option>
          <option value={"USA"}>USA </option>
          <option value={"U.K "}>U.K </option>
          <option value={"U.S"}>U.S</option>
        </Input>
      </Col>
      <Col xxl="5" sm="6" className="mb-3">
        <Label check>{ZipCode}</Label>
        <Input name="zip" type="text" value={zip} onChange={getUserData} />
      </Col>
      <Col xxl="4" sm="6" className="mb-3">
        <Label check>{ContactNumber}</Label>
        <Input type="number" placeholder={EnterNumber} name="contact" value={contact} onChange={getUserData}/>
      </Col>
      <Col xs="12">
        <FormGroup check >
          <Input  id="invalidCheck-n" type="checkbox" required/>
          <Label htmlFor="invalidCheck-n" check>{AgreeToTermsAndConditions}</Label>
        </FormGroup>
      </Col>
      <Col xs="12" className="text-end">
        <Btn color="primary" onClick={handleNextButton}>{Next}</Btn>
      </Col>
      </Row>
    </Form>
  );
};

export default YourInfoForm;
